module.exports = __webpack_public_path__ + "static/media/차.af486e97.jpg";